import Button from '@material-ui/core/Button/Button';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import Logo from '../Logo';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        sampleInviteStyles: {
            paddingTop: 40,
            paddingBottom: 40,
            paddingRight: theme.spacing(4),
            paddingLeft: theme.spacing(4),
            marginTop: 23.86,
            background: '#fff',
            border: '1px solid #E3E3E3',
            borderRadius: 10,
            '& .logo': {
                marginBottom: 33.39,
            },
            '& .heading, & .body': {
                textAlign: 'left',
            },
            '& .heading': {
                fontSize: 24,
                lineHeight: '26px',
                marginBottom: theme.spacing(4),
            },
            '& .body': {
                fontSize: 16,
                lineHeight: '22px',
            },
            '& .signup-button': {
                margin: theme.spacing(4, 0),
            },
        },
    }),
);

const SampleInviteTemplate: React.FC = () => {
    const { sampleInviteStyles } = useStyles();
    return (
        <div className={sampleInviteStyles}>
            <Logo className="logo" />
            <div className="heading">
                <b>[User’s Name]</b> wants you to try Givelify
            </div>
            <div className="body">
                Hi <b>[Authorized Officer’s Name]</b>, <br />
                <br />
                <b>[User’s Name]</b> would like <b>[Organization’s Name]</b> to
                join Givelify.
                <br />
                <br />
                Givelify is a free app that lets donors give from their phone
                and tablets. Our no-contract signup is quick and free for your
                organization.
                <br />
                <br />
                Let’s turn your donors’ generosity into your good work,
                together.
            </div>
            <Button variant="contained" className="signup-button" disableRipple>
                Sign Up Now
            </Button>
            <div className="body">
                Learn more at <a href="#/">www.givelify.com</a>
                <br />
                <br />
                Your partner in philanthropy,
                <br />
                Team Givelify
            </div>
        </div>
    );
};

export default SampleInviteTemplate;
